import React, {useEffect}  from "react"
import useSelfCheckinNafigation from 'utils/useSelfCheckinNafigation';
import MessageScreen from "components/SelfCheckin/MessageScreen/MessageScreen"
import { useTranslation } from 'react-i18next';
import useStore from 'store/store'

import './ScanBoardingPass.scss'

export default function ScanBoardingPass({airline, navigate}){
  const {t} = useTranslation();


  const [redirect, ] = useSelfCheckinNafigation();
  const storeActions = useStore((state)=> state.actions);
  

  let text= t("PLEASE SCAN YOUR BOARDING PASS");

  useEffect(()=>{
    storeActions.openGate(redirect, false, navigate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <MessageScreen airline={airline} message={text} />    
    )
}